import { axiosAction } from '../../utils/axiosAction';
import { CALIBRATION_PROFILES_FETCH_ENTITIES } from '../action-types/calibration-profiles-types';
import { constructSearchObj } from '../../utils/utils';

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_CALIBRATION_PROFILES}`;

export const getEntities =
  (restaurantId = 0, meta?) =>
  async dispatch => {
    return axiosAction.get(
      `${ENDPOINT}${constructSearchObj({ restaurantId })}`,
      CALIBRATION_PROFILES_FETCH_ENTITIES,
      dispatch,
      { meta },
    );
  };
